import { useState, useEffect } from 'react';

function useViewport() {
  const [isSmallView, setIsSmallView] = useState(window.innerWidth <= 1300);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1090);
  const [is1000pxView, set1000pxView] = useState(window.innerWidth <= 1000);
  const [isTinyMobileView, setIsTinyMobileView] = useState(window.innerWidth <= 770);
  const [isVeryMobileView, setIsVeryMobileView] = useState(window.innerWidth <= 686); 

  useEffect(() => {
    const handleResize = () => {
      setIsSmallView(window.innerWidth <= 1300);
      setIsMobileView(window.innerWidth <= 1090);
      set1000pxView(window.innerWidth <= 1000);
      setIsTinyMobileView(window.innerWidth <= 770);
      setIsVeryMobileView(window.innerWidth <= 686);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { isVeryMobileView, isSmallView, isMobileView, is1000pxView, isTinyMobileView };
}

export default useViewport;
